import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../Loading";

class Agenda extends Component {
  getAgenda = () => {
    const { cCode } = this.props.location.params || {};
    const { agenda } = this.props.earlyVoting[cCode] || {};
    return agenda;
  };

  render() {
    const { dbSync } = this.props.earlyVoting || {};
    return dbSync ? (
      <>
        {/* VIEW CURRENT AGENDA */}
        <div className="row mt-3">
          <div className="col-2">
            <b>현재 안건</b>
          </div>
          <div className="col-8">{this.getAgenda() || "없음"}</div>
        </div>
      </>
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = state => ({
  earlyVoting: state.earlyVoting,
  location: state.location
});

export default connect(mapStateToProps)(Agenda);
